$('.slider').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
});
